export default __webpack_public_path__ + "img/870a9a4307734664c3061029867c4317.png";